/**
 * Select2
 */

export default function Select2() {
    const selectors = {
        'select2' : '.js-tra-cuu-select2',
    };

    this.init = () => {
        jQuery(function ($) {
            "use strict";
            $(selectors.select2).each(function(){
                let select = $(this);
                let placeholder = select.find('option[value=""]').text();
                let dropdownParent = select.data("dropdown-parent");
                let width = select.data("width");

                let args = {
                    placeholder: typeof placeholder != 'undefined' && placeholder.length ? placeholder : '',
                }
                if(typeof dropdownParent != "undefined") {
                    args.dropdownParent = jQuery(dropdownParent);
                }
                if(typeof width != "undefined") {
                    args.width = width;
                }

                select.select2(args).on('select2:select', function (e) {
                    const data = e.params.data;
                    location.href = data.id;
                });
            })

        });
    };
}
